import { Typography, Box, Stack, Grid2 } from "@mui/material";
import ClientInfoDetail from "./clientInfoDetail";
import ServiceScheduleDetail from "./serviceScheduleDetail";
import ServiceDetail from "./serviceDetail";
import ServiceAddressDetail from "./serviceAddressDetail";
import CareStatusDetail from "./careStatusDetail";
import AuthorizedContactDetail from "./authorizedContactDetail";
import EmergencyPlanningDetail from "./emergencyPlanningDetail";
import BillingInformation from "./billingInformation";
import LegalTermsDetail from "./legalTermsDetail";
import DocumentationDetail from "./documentationDetail";
import PaymentBaseRateDetails from "./paymentBaseRateDetails";

const ReviewDetail = ({ formData }) => {
  return (
    <>
      <Box mb={2}>
        <ClientInfoDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceScheduleDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <ServiceAddressDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <CareStatusDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <AuthorizedContactDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <EmergencyPlanningDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <DocumentationDetail formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <PaymentBaseRateDetails formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <BillingInformation formData={formData} fromReview={true} />
      </Box>
      <Box mb={2}>
        <LegalTermsDetail formData={formData} fromReview={true} />
      </Box>
    </>
  );
};
export default ReviewDetail;
